import React from 'react';
import { Link } from 'gatsby';

import CDNImage from '../common/cdn-image';

const SmallLinkListItem = (props) => (
  <Link
    to={`/${(props.node.table === 'Collections') ? 'collection' : 'essay'}/${props.node.data.Slug}`}
    className="small-link-list__item"
  >
    <div>
      <CDNImage
        imagePath={props.node.data.Featured_Image_Path}
        fit="crop"
        height={200}
        width={200}
      />
    </div>
    <div>
      <div className="post-type">
        {(props.node.table === 'Collections') ? 'Collection' : 'Essay'}
      </div>
      <div className="post-title">
        {props.node.data.Title}
      </div>
    </div>
  </Link>
);

export default SmallLinkListItem;